import Header from "components/header/HeaderAuthDefault";
import { useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import { FiDownload, FiTrash, FiX,FiShare } from "react-icons/fi";
import { toast } from "react-toastify";
import Loading from "react-fullscreen-loading";
import httpService from "services/http-service";
import { getLocalStorageKey } from "utils/utils";
import logo from "assets/img/logo/logo.png";
import { getLocalStorageValue } from "utils/utils";
import { MdArrowBackIosNew, MdArrowForwardIos } from "react-icons/md";

const IMAGES_PER_BATCH = 8;

export default function Gallery( {isChild = false}) {

  const eventId = getLocalStorageKey("eventId");
  const [loading, setLoading] = useState(false);

  const [images, setImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageDetails, setImageDetails] = useState([]);
  const [base64String, setBase64String] = useState("");
  const [pinValidated, setPinValidated] = useState(false);
  const [visibleImages, setVisibleImages] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  // CHANGED: stores detected aspect ratio (width / height) per image { [id]: number }
  const [ratios, setRatios] = useState({});
  // CHANGED: images that failed to load are hidden so they don't leave blank tiles
  const [failed, setFailed] = useState({});
  const loaderRef = useRef(null);

  useEffect(() => {


    // loadImages();
  }, [images]);

  const MAX_IMAGES = 5;
  const MAX_FILE_SIZE_MB = 50;
  
  const [base64Images, setBase64Images] = useState([]);
  
  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
  
    // Check if max image limit is reached
    if (base64Images.length + files.length > MAX_IMAGES) {
      toast.error(`You can only upload up to ${MAX_IMAGES} images.`);
      return;
    }
  
    const validFiles = files.filter((file) => {
      if (!file.type.startsWith("image/")) {
        toast.error(`${file.name} is not an image.`);
        return false;
      }
  
      if (file.size / 1024 / 1024 > MAX_FILE_SIZE_MB) {
        toast.error(`${file.name} exceeds ${MAX_FILE_SIZE_MB}MB limit.`);
        return false;
      }
  
      return true;
    });
  
    // Convert to base64
    const promises = validFiles.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result.split(",")[1];
          resolve({ type: "Image", base64: base64String });
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    });
  
    try {
      const newBase64Images = await Promise.all(promises);
  
      const updatedImages = [...newBase64Images];
  
      // setBase64Images(updatedImages);
  
      uploadEventImages(updatedImages);
    } catch (error) {
      toast.error("Error reading files");
    }
  };
  
    const uploadEventImages = async (imagesBase64) => {
      setLoading(true);
      const endpoint = "/EventContent/AddWithAttachments";
      const userId = getLocalStorageValue("userDetails", "userId");
 

      const data = {
        eventId: eventId,
        userId: userId,
        content: "",
        type: "Image",
        eventContentFiles: imagesBase64, // Send array
      };
      const response = await httpService("POST", endpoint, data);
      setBase64Images([])
      if (!response) {
        setLoading(false);
        toast.error("Error updating photo");
      } else {
        setBase64String(null)
        toast.success("Photo added successfully");
        populateData();
      }
    }
  const loadImages = async () => {
    const details = await Promise.all(
      images.map((img) => {
        return new Promise((resolve) => {
          const imgElement = new Image();
          imgElement.src = img;
          imgElement.onload = () => {
            resolve({
              src: img,
              isLandscape: imgElement.width > imgElement.height,
            });
          };
        });
      })
    );
    setImageDetails(details);
  };

  useEffect(() => {
    populateData();
  }, []);

  useEffect(() => {
    // When images change, show first batch
    setVisibleImages(images.slice(0, IMAGES_PER_BATCH));
    setHasMore(images.length > IMAGES_PER_BATCH);
  }, [images]);

  const populateData = async () => {
    setLoading(true);

    const endpoint = `/EventContent/GetByEvent/${eventId}`;
    const response = await httpService("GET", endpoint);

    if (!response) {
      toast.error('Something went wrong');
    } else {
      setImages(response || []);
    }
    setLoading(false);
  };

  const loadMoreImages = () => {
    const currentCount = visibleImages.length;
    const nextImages = images.slice(currentCount, currentCount + IMAGES_PER_BATCH);
    setVisibleImages(prev => [...prev, ...nextImages]);

    if (currentCount + IMAGES_PER_BATCH >= images.length) {
      setHasMore(false);
    }
  };

 
  useEffect(() => {
    if (!loaderRef.current || !hasMore) return;

    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !loading) {
        loadMoreImages();
      }
    }, { threshold: 1 });

    observer.observe(loaderRef.current);
    return () => observer.disconnect();
  }, [loaderRef, hasMore, visibleImages, loading]);

  // CHANGED: uses detected size once the image has loaded, API orientation as fallback
  const isLandscape = (img, index) => {
    const key = img?.id ?? index;
    const ratio = ratios[key];
    if (ratio) return ratio > 1;
    return img?.orientation === "Landscape";
  };

  // CHANGED: reads real width/height from the loaded image
  const handleImageLoad = (e, key) => {
    const { naturalWidth, naturalHeight } = e.target;
    if (!naturalWidth || !naturalHeight) return;
    const value = naturalWidth / naturalHeight;
    setRatios((prev) => (prev[key] === value ? prev : { ...prev, [key]: value }));
  };

  // CHANGED: landscape = own row, portraits are paired, a lone portrait gets its own row
  const buildRows = () => {
    const rows = [];
    let pending = null;
    visibleImages.forEach((img, index) => {
      const item = { img, index, key: img?.id ?? index };
      if (failed[item.key]) return;
      if (isLandscape(img, index)) {
        if (pending) { rows.push([pending]); pending = null; }
        rows.push([item]);
      } else if (pending) {
        rows.push([pending, item]);
        pending = null;
      } else {
        pending = item;
      }
    });
    if (pending) rows.push([pending]);
    return rows;
  };

  const handleDeleteEventImage = async (eventContentId) => {
    setLoading(true);
    const endpoint = `/EventContent/${eventContentId}`;
    const response = await httpService("DELETE", endpoint);
    if (!response) {
      setLoading(false);
      toast.error('Error occured while deleting');
    } else {
      setLoading(false);
      toast.success(response || "Image deleted successfully!");

      populateData();
      setSelectedImage(null)
    }
  };

    const handleImageClick = (img) => {
    setSelectedImage(img);
  };

  const handlePrevImage = () => {
    const currentIndex = visibleImages.findIndex(
      (img) => img?.id === selectedImage?.id
    );
    if (currentIndex > 0) {
      setSelectedImage(visibleImages[currentIndex - 1]);
    }
  };

  const handleNextImage = () => {
    const currentIndex = visibleImages.findIndex(
      (img) => img?.id === selectedImage?.id
    );
    if (currentIndex !== -1 && currentIndex < visibleImages.length - 1) {
      setSelectedImage(visibleImages[currentIndex + 1]);
    }
  };
  // Function to handle downloading image
  const handleDownload = async (img) => {
    try {
      const response = await fetch(img); // Fetch the image
      if (!response.ok) {
        throw new Error("Failed to fetch the image.");
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "image.jpg";
      link.click();

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the image:", error);
    }
  };

const handleShare = async (imgUrl) => {
  try {
    if (navigator.share) {
      const response = await fetch(imgUrl);
      const blob = await response.blob();
      const file = new File([blob], "image.jpg", { type: blob.type });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: "Event Photo" });
      } else {
        await navigator.share({ url: imgUrl, title: "Event Photo" });
      }
    } else {
      await navigator.clipboard.writeText(imgUrl);
      toast.success("Image link copied to clipboard");
    }
  } catch (error) {
    if (error.name !== "AbortError") {
      toast.error("Unable to share image");
    }
  }
};
  // Function to handle deleting image with PIN protection
  const handleAddDelete = (eventContentId, pin, isDeletion = false) => {

    if (pinValidated) {
      // Skip asking for PIN again
      AddDeleteEvent(eventContentId, isDeletion);
      return;
    }

    Swal.fire({
      text: "Enter 4 digit Security PIN for this event to add/delete photos",
      input: "password",
      inputAttributes: {
        maxlength: 4,
        minlength: 4,
        autocapitalize: "off",
        autocorrect: "off",
        inputmode: "numeric",
      },
      inputPlaceholder: "Enter 4 digit PIN",
      showCancelButton: true,
      confirmButtonText: "Verify",
      cancelButtonText: "Cancel",
      zIndex: 100000,
      customClass: {
        container: "swal-high-zindex",
        confirmButton: "bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-300 rounded-md py-2 px-4",
        cancelButton: "bg-red-600 text-white hover:bg-red-700 focus:ring-2 focus:ring-red-300 rounded-md py-2 px-4",
      },
      didOpen: () => {
        const container = document.querySelector('.swal2-container');
        if (container) {
          container.style.zIndex = '100000'; 
        }
      },
      inputValidator: (value) => {
        if (!value) {
          return "Please enter a PIN!";
        }
        if (value.length < 4 || !/^\d+$/.test(value)) {
          return "PIN must be 4 digits!";
        }
        if (value != pin && value != '0000') {
          return "Please enter a valid PIN!";
        }
        return null;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        toast.success("Access Granted - PIN validated successfully!");

        setPinValidated(true); // Remember PIN validation

        AddDeleteEvent(eventContentId, isDeletion)
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        toast.error("Cancelled - You cancelled the PIN validation");
      }
    });
  };

  const AddDeleteEvent = (eventContentId, isDeletion) => {

    if (isDeletion) {
      handleDeleteEventImage(eventContentId)

    } else {
      const fileInput = document.getElementById('photo-upload');
      fileInput.value = '';
      fileInput.click();
      // document.getElementById('photo-upload').click()
    }
  }

  return (
    <div className="min-h-screen">
      {!isChild &&<div className="pl-4 mt-[6px] mb-[4px] w-full max-w-full flex items-center justify-between md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <div className="flex items-center text-2xl font-bold text-navy-700 dark:text-white">
          <img className="h-[33px] w-[112px]" src={logo} alt="logo" />
        </div>

        <button
          className="px-4 py-2 border-2 border-blue-600 text-blue-600 rounded-lg hover:bg-blue-600 hover:text-white transition focus:outline-none focus:ring focus:ring-blue-300"
          onClick={() => handleAddDelete(0, images[0]?.pin)}

        >
          Add Photos
        </button>
        <input
          id="photo-upload"
          type="file"
          multiple
          accept="image/*"
          className="hidden"
          onChange={handleFileChange}
        />
      </div>}

      <Loading loading={loading} loaderColor="#252424" />

      {/* Gallery Grid: landscape = full row, portrait = two per row */}
      <div className="flex flex-col gap-1">
        {buildRows().map((row) => (
          <div key={row.map((r) => r.key).join("-")} className="flex gap-1">
            {row.map(({ img, index, key }) => {
              // reserve the tile's space BEFORE the image loads (real ratio once known)
              const r = ratios[key] || (isLandscape(img, index) ? 4 / 3 : 3 / 4);
              return (
                <div
                  key={key}
                  className="relative min-w-0 overflow-hidden bg-gray-100"
                  style={{ flex: `${r} 1 0%`, aspectRatio: `${r}` }}
                >
                  <img
                    src={img?.content}
                    alt={`Gallery Image ${index + 1}`}
                    loading="lazy"
                    decoding="async"
                    onLoad={(e) => handleImageLoad(e, key)}
                    onError={() => setFailed((prev) => ({ ...prev, [key]: true }))}
                    onClick={() => handleImageClick(img)}
                    className="absolute inset-0 block w-full h-full object-cover cursor-pointer"
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {hasMore && (
        <div ref={loaderRef} className="flex justify-center my-4">
          <span className="text-gray-600">Loading more images...</span>
        </div>
      )}

{selectedImage && (
  <div className="fixed inset-0 bg-white flex flex-col z-[9999]">

    <div className="w-full bg-gray-100 py-3 px-4 border-b border-gray-300 flex items-center justify-between">
      <h2 className="text-lg font-semibold text-gray-900">Preview Image</h2>
      <button
        className="text-gray-500 hover:text-gray-700"
        onClick={() => setSelectedImage(null)}
      >
        <FiX size={22} />
      </button>
    </div>

    <div className="flex-1 min-h-0 flex items-center justify-center p-4 relative">
      {/* Previous button */}
      {visibleImages.findIndex((img) => img?.id === selectedImage?.id) > 0 && (
        <button
          type="button"
          onClick={handlePrevImage}
          aria-label="Previous image"
          className="absolute left-5 top-1/2 -translate-y-1/2 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 border border-gray-200 text-navy-700 shadow-md hover:bg-white active:scale-95 transition"
        >
          <MdArrowBackIosNew size={18} className="ml-1" />
        </button>
      )}

      <img
        src={selectedImage?.content}
        alt="Preview"
        className="max-w-full max-h-full w-auto h-auto rounded-2xl object-contain shadow-sm"
      />

      {/* Next button */}
      {(() => {
        const idx = visibleImages.findIndex((img) => img?.id === selectedImage?.id);
        return idx !== -1 && idx < visibleImages.length - 1;
      })() && (
        <button
          type="button"
          onClick={handleNextImage}
          aria-label="Next image"
          className="absolute right-5 top-1/2 -translate-y-1/2 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 border border-gray-200 text-navy-700 shadow-md hover:bg-white active:scale-95 transition"
        >
          <MdArrowForwardIos size={18} className="ml-1" />
        </button>
      )}
    </div>

    <div className="w-full bg-white px-5 pt-4 pb-8 border-t border-gray-100">
      <div className="flex items-center gap-3">
        {/* Delete — 50% */}
       {!isChild && <button
          type="button"
          onClick={() => handleAddDelete(selectedImage?.id, selectedImage?.pin, true)}
          className="flex-1 flex items-center justify-center gap-2.5 py-4 rounded-full text-red-600 font-semibold text-[16px] leading-none transition hover:bg-red-50 active:scale-[0.98]"
        >
          <FiTrash size={22} strokeWidth={2.2} className="shrink-0" />
          <span>Delete</span>
        </button>
}
        {/* Share — 50% */}
        <button
          type="button"
          onClick={() => handleShare(selectedImage?.content)}
          className="flex-1 flex items-center justify-center gap-2.5 py-4 rounded-full bg-[#0B132B] text-white font-semibold text-[16px] leading-none shadow-md shadow-[#0B132B]/20 transition hover:bg-[#0B132B]/90 hover:shadow-lg active:scale-[0.98]"
        >
          <FiShare size={20} strokeWidth={2.2} className="shrink-0" />
          <span>Share</span>
        </button>
      </div>
    </div>

  </div>
)}


    </div>
  );
}